/**
 * Class to add leaflet.draw plugin on map.
 *
 *  You should implement the events of draw:created and draw:deleted
 *  to work correctly. See the Geofence_view.js file to exemple.
 *
 * @author: Kete Martins
 * Date: 26/12/13
 * Time: 08:59
 */


Greenmile.Geofence = Greenmile.Geofence || {};
Greenmile.Geofence.DrawTool = Greenmile.Geofence.DrawTool || {};

Greenmile.Geofence.DrawTool = function (map, color, entity) {

    this.drawnItems = new L.FeatureGroup();
    this.drawControl = null;
    this.points = null;

    this.setPoints = function (points) {
        this.points = points;
    };

    this.addDrawTool = function (color) {

        map.addLayer(this.drawnItems);

        var options = {
            position: 'topright',
            draw: {
                // Turns off this drawing tools that is not interesting to us
                polyline: false,
                marker: false,
                rectangle: false,
                circle: false,

                polygon: {
                    allowIntersection: false, // Restricts shapes to simple polygons
                    drawError: {
                        color: '#e1e100', // Color the shape will turn when intersects
                        message: Monet.I18n.getResourcesByKey('geofence.intersectionError') // Message that will show when intersect
                    },
                    shapeOptions: {
                        color: color || '#0000FF'
                    }
                }
            },
            edit: {
                featureGroup: this.drawnItems, //REQUIRED!!
                remove: false
            }
        };

        this.drawControl = new L.Control.Draw(options);

        map.addControl(this.drawControl);

    };

    this.enableDraw = function () {
        var divDrawPolygon = document.querySelector("#" + entity + " div.leaflet-draw-toolbar.leaflet-bar.leaflet-draw-toolbar-top");
        if (divDrawPolygon) {
            divDrawPolygon.style.display = 'block';
        }
    };

    this.disableDraw = function () {
        var divDrawPolygon = document.querySelector("#" + entity + " div.leaflet-draw-toolbar.leaflet-bar.leaflet-draw-toolbar-top");
        if (divDrawPolygon) {
            divDrawPolygon.style.display = 'none';
        }

    };

    this.i18nLeafletDraw = function () {

        L.drawLocal.draw.toolbar.actions.title = Monet.I18n.getResourcesByKey('geofence.draw.cancel');
        L.drawLocal.draw.toolbar.actions.text = Monet.I18n.getResourcesByKey('geofence.button.cancel');

        L.drawLocal.draw.toolbar.undo.title = Monet.I18n.getResourcesByKey('geofence.undo.deletethelastpoint');
        L.drawLocal.draw.toolbar.undo.text = Monet.I18n.getResourcesByKey('geofence.undo.deletethelastpoint');

        L.drawLocal.draw.toolbar.buttons.polygon = Monet.I18n.getResourcesByKey('geofence.draw');
        L.drawLocal.draw.handlers.polyline.error = '<strong>' + Monet.I18n.getResourcesByKey('geofence.draw.error') +
            '</strong>' + Monet.I18n.getResourcesByKey('geofence.intersectionError');
        L.drawLocal.draw.handlers.polygon.tooltip.start = Monet.I18n.getResourcesByKey('geofence.draw.start');
        L.drawLocal.draw.handlers.polygon.tooltip.cont = Monet.I18n.getResourcesByKey('geofence.draw.continue');
        L.drawLocal.draw.handlers.polygon.tooltip.end = Monet.I18n.getResourcesByKey('geofence.draw.end');

        L.drawLocal.edit.toolbar.actions.save.title = Monet.I18n.getResourcesByKey('geofence.button.save');
        L.drawLocal.edit.toolbar.actions.save.text = Monet.I18n.getResourcesByKey('geofence.button.save');
        L.drawLocal.edit.toolbar.actions.cancel.title = Monet.I18n.getResourcesByKey('geofence.draw.cancel.editions');
        L.drawLocal.edit.toolbar.actions.cancel.text = Monet.I18n.getResourcesByKey('geofence.button.cancel');

        L.drawLocal.edit.handlers.edit.tooltip.text = Monet.I18n.getResourcesByKey('geofence.draw.instructions.edit');
        L.drawLocal.edit.handlers.edit.tooltip.subtext = Monet.I18n.getResourcesByKey('geofence.draw.instructions.cancel');

        L.drawLocal.edit.handlers.edit.tooltip.text = Monet.I18n.getResourcesByKey('geofence.button.cancel');
        L.drawLocal.edit.handlers.remove.tooltip.text = Monet.I18n.getResourcesByKey('geofence.draw.instructions.delete');

    };

    this.init = function () {
        this.addDrawTool(color);
        this.i18nLeafletDraw();
    };
};